import { Box } from '@mui/material';
import { RedoIcon, UndoIcon } from '~/assets/workspace-icons';
import ToolbarButton from '~/components/toolbar/shared/ToolbarButton';
import { useStructureToolGating } from '~/components/toolbar/shared/useStructureToolGating';
import { useUndoRedo } from '~/hooks/undo/useUndoRedo';

export default function UndoRedoTool() {
    const { selectedRoiNumber, structureSetEditDisabled, isSelectionApproved } =
        useStructureToolGating();
    const { canUndo, canRedo, undo, redo } = useUndoRedo(selectedRoiNumber);

    const getUndoTooltip = (): string => {
        if (isSelectionApproved) {
            return 'Structure is approved';
        }
        return canUndo ? 'Undo last change' : 'Nothing to undo';
    };

    const getRedoTooltip = (): string => {
        if (isSelectionApproved) {
            return 'Structure is approved';
        }
        return canRedo ? 'Redo last change' : 'Nothing to redo';
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.25,
            }}
        >
            <ToolbarButton
                icon={<UndoIcon />}
                tooltip={getUndoTooltip()}
                disabled={
                    !canUndo || structureSetEditDisabled || isSelectionApproved
                }
                onClick={undo}
            />
            <ToolbarButton
                icon={<RedoIcon />}
                tooltip={getRedoTooltip()}
                disabled={
                    !canRedo || structureSetEditDisabled || isSelectionApproved
                }
                onClick={redo}
            />
        </Box>
    );
}
